
import { useEkardoLazyQuery } from '@netfront/ekardo-content-library';
import { GET_CONTENT_GROUP_QUERY } from './useGetContentGroup.graphql';
import {
  IGetContentGroupQueryGraphQLResponse,
  IGetContentGroupQueryVariables,
  IHandleGetContentGroupParams,
  IUseGetContentGroup,
  IUseGetContentGroupOptions,
} from './useGetContentGroup.interfaces';

const useGetContentGroup = (options?: IUseGetContentGroupOptions): IUseGetContentGroup => {
  const { fetchPolicy, onCompleted, onError, product, query, tokens } = options ?? ({} as IUseGetContentGroupOptions);

  const [executeGetContentGroup, { loading: isLoading }] = useEkardoLazyQuery<
    IGetContentGroupQueryGraphQLResponse,
    IGetContentGroupQueryVariables
  >({
    options: {
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          contentGroup: { getContentGroup: contentGroup },
        } = data;

        onCompleted({
          contentGroup,
        });
      },
      onError,
    },
    product,
    query: query ?? GET_CONTENT_GROUP_QUERY,
    tokens,
  });

  const handleGetContentGroup = async ({ contentPage, contentGroupId, topLevelOnly }: IHandleGetContentGroupParams) => {
    const { id: contentPageId = 0, userFlowStepTrackId = 0, withAnswers: shouldIncludeAnswers = false } = contentPage ?? {};

    await executeGetContentGroup({
      variables: {
        contentGroupId,
        contentPageId,
        topLevelOnly,
        userFlowStepTrackId,
        withAnswers: shouldIncludeAnswers,
      },
    });
  };

  return {
    handleGetContentGroup,
    isLoading,
  };
};

export { useGetContentGroup };
